(() => {
  const CLASSES = {
    root: 'app-guide',
    track: 'app-guide__track',
    viewport: 'app-guide__viewport',
    navBtn: 'app-guide__nav-btn',
    indexBtn: 'app-guide__index-btn',
    sidebarBtn: 'app-guide__sidebar-btn',
    detailsToggle: 'app-guide__card-details-toggle',
    details: 'app-guide__card-details',
    counter: 'app-guide__counter'
  };

  const DATA = {
    prev: 'data-app-guide-prev',
    next: 'data-app-guide-next',
    index: 'data-app-guide-index',
    sidebar: 'data-app-guide-sidebar',
    step: 'data-app-guide-step',
    detailsToggle: 'data-app-guide-details-toggle',
    details: 'data-app-guide-details',
    counter: 'data-app-guide-counter'
  };

  function initSection(section) {
    const track = section.querySelector(`.${CLASSES.track}`);
    const viewport = section.querySelector(`.${CLASSES.viewport}`);
    const prevBtn = section.querySelector(`[${DATA.prev}]`);
    const nextBtn = section.querySelector(`[${DATA.next}]`);
    const indexBtns = section.querySelectorAll(`.${CLASSES.indexBtn}`);
    const sidebarBtns = section.querySelectorAll(`.${CLASSES.sidebarBtn}`);
    const counter = section.querySelector(`.${CLASSES.counter}`);

    if (!track || !viewport) return;

    const cards = Array.from(track.children);
    const total = cards.length;
    if (total === 0) return;

    let current = 0;
    let isDesktop = window.matchMedia('(min-width: 992px)').matches;
    let touchStartX = 0;
    let touchEndX = 0;
    const SWIPE_THRESHOLD = 50;

    function goTo(index) {
      if (index < 0 || index >= total) return;
      current = index;

      if (!isDesktop) {
        track.style.transform = `translateX(-${current * 100}%)`;
      }

      updateNavButtons();
      updateIndex();
      updateSidebar();
      updateCounter();
      showActiveCard(index);
    }

    function showActiveCard(index) {
      if (isDesktop) {
        for (const card of cards) {
          card.style.display = 'none';
        }
        cards[index].style.display = 'flex';
        if (viewport) viewport.scrollTop = 0;
      }
    }

    function updateNavButtons() {
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === total - 1;
    }

    function updateIndex() {
      for (const btn of indexBtns) {
        const step = parseInt(btn.getAttribute(DATA.index), 10);
        if (step === current) {
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.removeAttribute('aria-current');
        }
      }
    }

    function updateSidebar() {
      for (const btn of sidebarBtns) {
        const step = parseInt(btn.getAttribute(DATA.sidebar), 10);
        if (step === current) {
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.removeAttribute('aria-current');
        }
      }
    }

    function updateCounter() {
      if (!counter) return;
      counter.innerHTML = `<span>${current + 1}</span> / ${total}`;
    }

    function onPrev() {
      goTo(current - 1);
    }

    function onNext() {
      goTo(current + 1);
    }

    function onTouchStart(e) {
      touchStartX = e.changedTouches[0].screenX;
    }

    function onTouchEnd(e) {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) < SWIPE_THRESHOLD) return;
      if (diff > 0) {
        onNext();
      } else {
        onPrev();
      }
    }

    function onBreakpointChange() {
      const wasDesktop = isDesktop;
      isDesktop = window.matchMedia('(min-width: 992px)').matches;

      if (isDesktop !== wasDesktop) {
        if (isDesktop) {
          track.style.transform = '';
          for (const card of cards) {
            card.style.display = 'none';
          }
          cards[current].style.display = 'flex';
        } else {
          for (const card of cards) {
            card.style.display = '';
          }
          track.style.transform = `translateX(-${current * 100}%)`;
        }
      }
    }

    function initDetailsToggles() {
      const toggles = section.querySelectorAll(`.${CLASSES.detailsToggle}`);
      for (const toggle of toggles) {
        toggle.addEventListener('click', () => {
          const detailsId = toggle.getAttribute('aria-controls');
          const details = section.querySelector(`#${detailsId}`);
          if (!details) return;

          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!expanded));
          details.setAttribute('aria-hidden', String(expanded));
        });
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', onPrev);
    if (nextBtn) nextBtn.addEventListener('click', onNext);

    for (const btn of indexBtns) {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.getAttribute(DATA.index), 10);
        goTo(step);
      });
    }

    for (const btn of sidebarBtns) {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.getAttribute(DATA.sidebar), 10);
        goTo(step);
      });
    }

    viewport.addEventListener('touchstart', onTouchStart, { passive: true });
    viewport.addEventListener('touchend', onTouchEnd, { passive: true });

    const mql = window.matchMedia('(min-width: 992px)');
    mql.addEventListener('change', onBreakpointChange);

    initDetailsToggles();

    if (isDesktop) {
      for (const card of cards) {
        card.style.display = 'none';
      }
      cards[0].style.display = 'flex';
    }

    updateNavButtons();
    updateIndex();
    updateSidebar();
    updateCounter();
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll(`.${CLASSES.root}`);
    for (const section of sections) {
      initSection(section);
    }
  });
})();
